import LoadingScreen from "../../LoadingScreen";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBoards } from "../../../../Services/boardsService";
import Navbar from "../../Navbar";
import { Container, Wrapper, Title, Board, AddBoard } from "./Styled";
import CreateBoard from "../../Modals/CreateBoardModal/CreateBoard";
import { useNavigate } from "react-router";
import { useAppContext } from "../../../../context/useContext";

const Boards = () => {
  const { autoFetch } = useAppContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pending, boardsData } = useSelector((state) => state.boards);
  const [openModal, setOpenModal] = useState(false);
  const [searchString, setSearchString] = useState("");
  const handleModalClose = () => {
    setOpenModal(false);
  };

  const handleClick = (e) => {
    navigate(`/task/board/${e.target.id}`);
  };

  useEffect(() => {
    getBoards(false, dispatch, autoFetch);
  }, [dispatch, autoFetch]);

  useEffect(() => {
    document.title = "Quản lý công việc";
  }, []);

  return (
    <>
      {pending && <LoadingScreen />}
      <Container>
        <Navbar searchString={searchString} setSearchString={setSearchString} />
        <Wrapper>
          <Title>Dự án của bạn</Title>
          {!pending &&
            boardsData.length > 0 &&
            boardsData
              .filter((item) =>
                searchString
                  ? item.title
                      .toLowerCase()
                      .includes(searchString.toLowerCase())
                  : true
              )
              .map((item) => {
                return (
                  <Board
                    key={item._id}
                    link={item.backgroundImageLink}
                    isImage={item.isImage}
                    id={item._id}
                    onClick={(e) => handleClick(e)}
                  >
                    {item.title}
                  </Board>
                );
              })}
          {!pending && (
            <AddBoard onClick={() => setOpenModal(true)}>
              Tạo dự án mới
            </AddBoard>
          )}
          {openModal && <CreateBoard callback={handleModalClose} />}
        </Wrapper>
      </Container>
    </>
  );
};

export default Boards;
